import { __assign } from "tslib";
import * as React from 'react';
import { StyleSheet } from 'react-native';
import PnmacStyledText from './PnmacStyledText';
// @component-group Typography
/**
 * Typography component for showing a subheading.
 *
 * <div class="screenshots">
 *   <img src="screenshots/subheading.png" />
 * </div>
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { PnmacSubheading } from 'pnmac-universal-components';
 *
 * const MyComponent = () => (
 *   <PnmacSubheading>Subheading</PnmacSubheading>
 * );
 *
 * export default MyComponent;
 * ```
 */
var PnmacSubheading = function (props) {
  return /*#__PURE__*/React.createElement(PnmacStyledText, __assign({}, props, {
    alpha: 0.87,
    family: "regular",
    style: [styles.text, props.style]
  }));
};
export default PnmacSubheading;
var styles = StyleSheet.create({
  text: {
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: 0.5
  }
});